import { Box, Flex, FormLabel, Heading } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainInput from "../../../../components/Form/input";
import MainModel from "../../../../components/Models/main-model";
import { closeAddLiveVideoModel } from "../../../../modules/admin-modules/models/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";
import {
  createLiveVideoRequest,
  updateLiveVideoRequest,
} from "../../../../modules/superadmin-modules/live-videos/Actions";

const AddLiveVideo = ({ isAdd, data, setSelectedData }) => {
  const openLiveVideo = useSelector((state) => state.model.isOpen37);
  const isLoading = useSelector((state) => state.superadminLiveVideos.isLoading);
  const courses = useSelector((state) => state.courses.courses);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  const dispatch = useDispatch();

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });

  const defaultCourse = {
    label: data?.course?.name,
    value: data?.course?.id,
  };

  useEffect(() => {
    dispatch(getAllCoursesRequest());
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة فيديو مباشر" : "تعديل فيديو مباشر"}
      </Heading>
    </Box>
  );

  const onSubmit = async (values) => {
    const action = () => {
      dispatch(closeAddLiveVideoModel());
      setSelectedData({});
      reset();
    };
    if (isAdd) {
      let formData = await new FormData();
      formData.append("title", values?.title);
      formData.append("zoom_link", values?.zoom_link);
      formData.append("course_id", values?.course_id);

      console.log("Dispatching createLiveVideoRequest with formData:", formData);
      await dispatch(createLiveVideoRequest(formData, action));
    } else {
      let formData = await new FormData();
      formData.append("_method", "PUT");
      const total = { ...data, ...values };
      formData.append("title", total?.title);
      formData.append("zoom_link", total?.zoom_link);
      formData.append("course_id", total?.course_id);

      dispatch(
        updateLiveVideoRequest(data?.id, formData, action)
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeAddLiveVideoModel());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openLiveVideo}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex
          dir="rtl"
          w="100%"
          flexWrap="wrap"
          justifyContent="space-between"
          gap="4"
        >
          <Box w="45%">
            <MainInput
              label="العنوان"
              defaultValues={data?.title}
              error={errors?.title?.message}
              placeholder="ادخل عنوان الفيديو المباشر"
              register={register}
              name="title"
            />
          </Box>
          <Box w="45%">
            <MainInput
              label="الرابط"
              defaultValues={data?.zoom_link}
              error={errors?.zoom_link?.message}
              placeholder="ادخل رابط الفيديو المباشر"
              register={register}
              name="zoom_link"
            />
          </Box>
          <Box w="45%">
            <FormLabel>الدورة : </FormLabel>
            <Select
              options={coursesOptions}
              onChange={(data) => setValue("course_id", data.value)}
              styles={colourStyles}
              placeholder="الدورة"
              defaultValue={defaultCourse}
            />
          </Box>
        </Flex>
      </form>
    </MainModel>
  );
};

export default AddLiveVideo; 